//export const homePath = '/home';
export const homePath = '/admin/internal-users';
export const applicationAccess = 'SYSADMIN';
export const subsidiaries = ['SG','JP','MU', "EU", "HK", "CN", "RESELLER"];
